// src/config.js
const API_URL = "http://localhost:4000/api"; 
// or later: window.__WIDGET_CONFIG__.API_URL

export default {
  API_URL,
};
